var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideProgressBar)?_c('div',{staticClass:"progress-bar-wrapper"},[_c('div',{staticClass:"step-progress-bar"},_vm._l((_vm.overallSteps),function(step,i){return _c('div',{key:i,staticClass:"step"},[_c('div',{class:_vm.getClasses(i)},[_c('div',{staticClass:"inner-circle"})])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }